import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { ConsumerAdminService } from "../../../services/api/consumer-admin.service";
import { ConsumerAdminActions } from "../../actions/consumer-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class BoUpdateEffects {
	update = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerAdminActions.bo.update),
			switchMap((action) =>
				this.consumerAdminService.updateBeneficialOwner(action.id, action.body).pipe(
					map(() => ConsumerAdminActions.bo.updateSuccess()),
					catchError((error) =>
						of(ConsumerAdminActions.bo.updateFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private consumerAdminService: ConsumerAdminService
	) {}
}
